import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { useSmartBack } from "@/hooks/useSmartBack";

interface BackButtonProps {
  to?: string;
  onClick?: () => void;
  smart?: boolean;
}

export const BackButton = observer(function BackButton({ to, onClick, smart }: BackButtonProps) {
  const { t } = useLanguage();
  const { backTo } = useSmartBack();

  if (onClick) {
    return (
      <Button
        variant="ghost"
        size="icon"
        className="ml-0 rounded-full"
        onClick={onClick}
        aria-label={t?.common?.back ?? "Back"}
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      </Button>
    );
  }

  // Use smart destination when smart prop is set and no explicit `to` is given
  const destination = to ?? (smart ? backTo : "/buildings");

  return (
    <Link to={destination}>
      <Button
        variant="ghost"
        size="icon"
        className="ml-0 rounded-full"
        aria-label={t?.common?.back ?? "Back"}
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      </Button>
    </Link>
  );
});
